
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memberships/[membershipId]",
      function () {
        return require("private-next-pages/memberships/[membershipId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memberships/[membershipId]"])
      });
    }
  